import { CONFIG_CODES } from '../types';

export function getConfig(item: CONFIG_CODES): string {
  return globalThis.window[CONFIG_CODES[item]];
}
